import { render, staticRenderFns } from "./RadioButton.vue?vue&type=template&id=1156e2c3&scoped=true"
import script from "./RadioButton.vue?vue&type=script&lang=ts"
export * from "./RadioButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1156e2c3",
  null
  
)

export default component.exports